import axios from 'axios';
import { handleAxiosAuthError } from '../utils/authErrorHandler';

const API_BASE_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const user = localStorage.getItem('user');
  if (user) {
    try {
      const userData = JSON.parse(user);
      if (userData.id) {
        config.headers['X-User-Id'] = userData.id;
      }
    } catch (e) {
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      return handleAxiosAuthError(error);
    }
    return Promise.reject(error);
  }
);

export class InterviewConversationAPI {
  static async getConversation(recordId) {
    try {
      const { data } = await api.get(`/api/v1/mock-interview/records/${recordId}/conversation`);
      return { success: true, data };
    } catch (error) {
      return { success: false, error: error.response?.data?.detail || error.message || '获取失败' };
    }
  }

  static async persistConversation(recordId, messages, questions) {
    try {
      const payload = { messages };
      if (Array.isArray(questions) && questions.length > 0) {
        payload.questions = questions;
      }
      const { data } = await api.post(`/api/v1/mock-interview/records/${recordId}/conversation/persist`, payload);
      return { success: true, data };
    } catch (error) {
      return { success: false, error: error.response?.data?.detail || error.message || '保存失败' };
    }
  }

  static async generateSuggestedAnswer(recordId, round) {
    try {
      const { data } = await api.post(`/api/v1/mock-interview/records/${recordId}/conversation/suggest`, { round });
      return { success: true, data };
    } catch (error) {
      return { success: false, error: error.response?.data?.detail || error.message || '生成失败' };
    }
  }
}

